<!--
    @全周期
-->
<template>
    <div>
        <div class="main-content fullCycle fullCss" :style="mainContentViewHeight" v-loading.lock="fullscreenLoading">
            <headerCom :datacount="navTotal" :tabs="false" :type="3" @navchange="navClickHandle"
                @searchclick="searchClickHandle" @showBox="showBoxHandle" class="header"></headerCom>
            <screenCom :navClick="systemType" :projectTypeList="projectTypeList" :type="4"
                @projectemit="projectEmitHandle" class="screen" v-if="showFlag"></screenCom>
            <div class="my_table">
                <div class="no_message" v-if="dataMsg.length == 0">
                    <!-- <img src="../../../assets/images/empty.png" alt=""> -->
                    <p>暂无数据</p>
                </div>
                <div class="project_item" v-else>
                    <div class="radioBox">
                        <div><span style="background:#1890FF"></span>未超出操作时效范围</div>
                        <div><span style="background:#ffc500"></span>快要超出操作时效范围</div>
                        <div><span style="background:#FF9900"></span>即将超出操作时效范围</div>
                        <div><span style="background:#F23030"></span>已超出操作时效范围</div>
                        <div><span style="background:#FFFFFF"></span>未到该操作环节</div>
                    </div>
                    <projectCom :data="item" :hasViewBtnPer="hasBtnPermission('supperviseion_flowEff_detail_btn')"
                        :key="i" :systemType="systemType" :type="4" class="project_par" v-for="(item, i) in dataMsg"
                        :clickRowEvent="false"
                        >
                    </projectCom>
                </div>
                <paginationCom class="limit" :options="paginationOpt" @sizechange="sizeChangeHandle"
                    @pagechange="pageChangeHandle"></paginationCom>
            </div>
        </div>
    </div>
</template>
<script>
import headerCom from '../../components/header.vue';
import screenCom from '../../components/screen.vue';
import projectCom from '../../components/project-com.vue';
import { mapState } from 'vuex';
import { listFlowEfficiencyListPaged, dictDataList } from '@/server/busWitnessList.js';
export default {
    props: ["mainContentViewHeight"],
    components: {
        headerCom,
        screenCom,
        projectCom
    },
    data() {
        return {
            fullscreenLoading: false,
            systemType: 'GC',
            radio: 1,
            navTotal: { CG: 0, GC: 0, GT: 0, CQ: 0 },
            dataMsg: [
                // {
                //     "bidSectionCode":"E4111000760210504001001",
                //     "bidSectionName":"黄石市淞江产业集聚区大健康循环经济产业园及配套基础设施建设项目标准化厂房一期一标段",
                //     "flownodeList":[
                //         {
                //             "datasetCode":"A03",
                //             "enableHandle":1,
                //             "flowId":"1640075371135008",
                //             "flowWitnessId":"274b87fce010460abca2f7a075c42412",
                //             "nodeName":"招标项目登记",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:32:04",
                //             "sort":1,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A07",
                //             "enableHandle":1,
                //             "flowId":"1640076160525005",
                //             "flowWitnessId":"64a8b23f5cee40e2b1c26aaafcc4ea97",
                //             "nodeName":"招标文件",
                //             "nodeProgressType":2,
                //             "nodeTime":"2021-12-21 16:43:36",
                //             "sort":4,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A10",
                //             "enableHandle":1,
                //             "flowId":"1640075587939007",
                //             "flowWitnessId":"f72a2ff852324a1fbc443f497d500e4d",
                //             "nodeName":"招标公告",
                //             "nodeProgressType":2,
                //             "nodeTime":"2021-12-21 16:35:31",
                //             "sort":5,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A23",
                //             "enableHandle":0,
                //             "nodeName":"招标文件澄清与修改",
                //             "nodeProgressType":4,
                //             "sort":64,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A34",
                //             "enableHandle":0,
                //             "nodeName":"开标监管",
                //             "nodeProgressType":4,
                //             "sort":89,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A29",
                //             "enableHandle":1,
                //             "nodeName":"评标监管",
                //             "nodeProgressType":4,
                //             "sort":101,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A31",
                //             "enableHandle":1,
                //             "nodeName":"中标候选人公示",
                //             "nodeProgressType":4,
                //             "sort":102,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"中标结果公告",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"发起投诉",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A40",
                //             "enableHandle":1,
                //             "nodeName":"招标异常",
                //             "nodeProgressType":0,
                //             "sort":120,
                //             "witnessStatus":0
                //         }
                //     ],
                //     "passDate":1,
                //     "passOpenDate":0,
                //     "tenderAgencyName":"中共黄石市郾城区交通运输局纪检组",
                //     "tenderMode":"河南天百康工程管理咨询有限公司",
                //     "tenderModeName":"公开招标",
                //     "qualificationModeName":'资格后审',
                //     "winerName":"漯河经济技术开发区晟恒建设发展",
                //     "tendererName":"中共黄石市郾城区交通运输局纪检组",
                //     "warnItemCount":1,
                //     "openTime":'2021-11-02 8:30'
                // },
                // {
                //     "bidSectionCode":"E4111000760210504001001",
                //     "bidSectionName":"郾城区前周村城中村改造建设项目（漯河·昌建誉峰；建业·沙河云境）前期物业服务项目",
                //     "flownodeList":[
                //         {
                //             "datasetCode":"A03",
                //             "enableHandle":1,
                //             "flowId":"1640075371135008",
                //             "flowWitnessId":"274b87fce010460abca2f7a075c42412",
                //             "nodeName":"招标项目登记",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:32:04",
                //             "sort":1,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A34",
                //             "enableHandle":0,
                //             "nodeName":"资审文件",
                //             "nodeProgressType":2,
                //             "sort":89,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A23",
                //             "enableHandle":0,
                //             "nodeName":"招标文件澄清与修改",
                //             "nodeProgressType":2,
                //             "sort":64,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A07",
                //             "enableHandle":1,
                //             "flowId":"1640076160525005",
                //             "flowWitnessId":"64a8b23f5cee40e2b1c26aaafcc4ea97",
                //             "nodeName":"招标文件",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:43:36",
                //             "sort":4,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A10",
                //             "enableHandle":1,
                //             "flowId":"1640075587939007",
                //             "flowWitnessId":"f72a2ff852324a1fbc443f497d500e4d",
                //             "nodeName":"招标公告",
                //             "nodeProgressType":3,
                //             "nodeTime":"2021-12-21 16:35:31",
                //             "sort":5,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A29",
                //             "enableHandle":1,
                //             "nodeName":"评标监管",
                //             "nodeProgressType":1,
                //             "sort":101,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A31",
                //             "enableHandle":1,
                //             "nodeName":"中标候选人公示",
                //             "nodeProgressType":1,
                //             "sort":102,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"中标结果公告",
                //             "nodeProgressType":2,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"发起投诉",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A40",
                //             "enableHandle":1,
                //             "nodeName":"招标异常",
                //             "nodeProgressType":4,
                //             "sort":120,
                //             "witnessStatus":0
                //         }
                //     ],
                //     "passDate":1,
                //     "passOpenDate":0,
                //     "tenderAgencyName":"中共黄石市郾城区交通运输局纪检组",
                //     "tenderMode":"河南天百康工程管理咨询有限公司",
                //     "tenderModeName":"公开招标",
                //     "qualificationModeName":'资格后审',
                //     "winerName":"南泰昌建设管理咨询有限公司",
                //     "tendererName":"中共黄石市郾城区交通运输局纪检组",
                //     "warnItemCount":10,
                //     "openTime":'2021-10-22 8:30 '
                // },
                // {
                //     "bidSectionCode":"E4111000760210504001001",
                //     "bidSectionName":"黄石市淞江产业集聚区大健康循环经济产业园及配套基础设施建设项目标准化厂房一期一标段",
                //     "flownodeList":[
                //         {
                //             "datasetCode":"A03",
                //             "enableHandle":1,
                //             "flowId":"1640075371135008",
                //             "flowWitnessId":"274b87fce010460abca2f7a075c42412",
                //             "nodeName":"招标项目登记",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:32:04",
                //             "sort":1,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A07",
                //             "enableHandle":1,
                //             "flowId":"1640076160525005",
                //             "flowWitnessId":"64a8b23f5cee40e2b1c26aaafcc4ea97",
                //             "nodeName":"招标文件",
                //             "nodeProgressType":2,
                //             "nodeTime":"2021-12-21 16:43:36",
                //             "sort":4,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A10",
                //             "enableHandle":1,
                //             "flowId":"1640075587939007",
                //             "flowWitnessId":"f72a2ff852324a1fbc443f497d500e4d",
                //             "nodeName":"投标邀请书",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:35:31",
                //             "sort":5,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A23",
                //             "enableHandle":0,
                //             "nodeName":"招标文件澄清与修改",
                //             "nodeProgressType":1,
                //             "sort":64,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A34",
                //             "enableHandle":0,
                //             "nodeName":"开标监管",
                //             "nodeProgressType":4,
                //             "sort":89,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A29",
                //             "enableHandle":1,
                //             "nodeName":"评标监管",
                //             "nodeProgressType":4,
                //             "sort":101,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A31",
                //             "enableHandle":1,
                //             "nodeName":"中标候选人公示",
                //             "nodeProgressType":4,
                //             "sort":102,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"中标结果公告",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"发起投诉",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A40",
                //             "enableHandle":1,
                //             "nodeName":"招标异常",
                //             "nodeProgressType":4,
                //             "sort":120,
                //             "witnessStatus":0
                //         }
                //     ],
                //     "passDate":1,
                //     "passOpenDate":0,
                //     "tenderAgencyName":"中共黄石市郾城区交通运输局纪检组",
                //     "tenderMode":"汇通建设集团股份有限公司",
                //     "tenderModeName":"公开招标",
                //     "qualificationModeName":'资格后审',
                //     "winerName":"黄石市源汇区空冢郭镇人民政府",
                //     "tendererName":"中共黄石市郾城区交通运输局纪检组",
                //     "warnItemCount":5,
                //     "openTime":'2021-11-02 8:30'
                // },
                // {
                //     "bidSectionCode":"E4111000760210504001001",
                //     "bidSectionName":"临颍县舒美家园城市棚户区改造项目一期前期物业服务项目设施建设项目",
                //     "flownodeList":[
                //         {
                //             "datasetCode":"A03",
                //             "enableHandle":1,
                //             "flowId":"1640075371135008",
                //             "flowWitnessId":"274b87fce010460abca2f7a075c42412",
                //             "nodeName":"招标项目登记",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:32:04",
                //             "sort":1,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A07",
                //             "enableHandle":1,
                //             "flowId":"1640076160525005",
                //             "flowWitnessId":"64a8b23f5cee40e2b1c26aaafcc4ea97",
                //             "nodeName":"招标文件",
                //             "nodeProgressType":2,
                //             "nodeTime":"2021-12-21 16:43:36",
                //             "sort":4,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A10",
                //             "enableHandle":1,
                //             "flowId":"1640075587939007",
                //             "flowWitnessId":"f72a2ff852324a1fbc443f497d500e4d",
                //             "nodeName":"招标公告",
                //             "nodeProgressType":1,
                //             "nodeTime":"2021-12-21 16:35:31",
                //             "sort":5,
                //             "witnessStatus":1
                //         },
                //         {
                //             "datasetCode":"A23",
                //             "enableHandle":0,
                //             "nodeName":"招标文件澄清与修改",
                //             "nodeProgressType":1,
                //             "sort":64,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A34",
                //             "enableHandle":0,
                //             "nodeName":"开标监管",
                //             "nodeProgressType":1,
                //             "sort":89,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A29",
                //             "enableHandle":1,
                //             "nodeName":"评标监管",
                //             "nodeProgressType":1,
                //             "sort":101,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A31",
                //             "enableHandle":1,
                //             "nodeName":"中标候选人公示",
                //             "nodeProgressType":4,
                //             "sort":102,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"中标结果公告",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A32",
                //             "enableHandle":1,
                //             "nodeName":"发起投诉",
                //             "nodeProgressType":4,
                //             "sort":104,
                //             "witnessStatus":0
                //         },
                //         {
                //             "datasetCode":"A40",
                //             "enableHandle":1,
                //             "nodeName":"招标异常",
                //             "nodeProgressType":4,
                //             "sort":120,
                //             "witnessStatus":0
                //         }
                //     ],
                //     "passDate":1,
                //     "passOpenDate":0,
                //     "tenderAgencyName":"中共黄石市郾城区交通运输局纪检组",
                //     "tenderMode":"河南天百康工程管理咨询有限公司",
                //     "tenderModeName":"公开招标",
                //     "qualificationModeName":'资格后审',
                //     "winerName":"河南天桥建设有限公司",
                //     "tendererName":"中共黄石市郾城区交通运输局纪检组",
                //     "warnItemCount":0,
                //     "openTime":'2021-11-02 8:30'
                // },
            ],
            projectTypeList: [],
            paginationOpt: {
                pageIndex: 1,
                pageSize: 4,
                total: 0,
                pageSizes: [4, 10, 15]
            },
            showFlag: false,
            searchKey: '',
            projectStatusType: '',
            bidOpenTimeStar: '',
            bidOpenTimeEnd: '',
            buyprojectresultnoticeTimeStart: '',
            buyprojectresultnoticeTimeEnd: '',
            projecEntryTimeStart: '',
            projecEntryTimeEnd: '',
            superviseDeptCodeList: []
        }
    },
    watch: {
        uerdefultOptionCode: {
            handler(val, oldVal) {
                if (val.length !== 0) { this.init() }
            }
        }
    },

    computed: {
        // ...mapState([
        // 	'user',
        // ])
        ...mapState({
            uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        })

    },
    mounted() {
        // this.apiworkBenchIndexcountProjectTracking();
        this.apiSysdatadictionaryGetDictionaryName();
        this.init();
    },
    methods: {

        showBoxHandle(val) {//是否显示高级搜索
            this.showFlag = val;
            if (this.showFlag == false) {
                this.buyprojectresultnoticeTimeEnd = '';
                this.buyprojectresultnoticeTimeStart = '';
                this.bidOpenTimeEnd = "";
                this.bidOpenTimeStart = "";
                this.resultNoticeEndTime = "";
                this.resultNoticeStartTime = "";
                this.buyprojectType = ""
                this.projectStatus = 0
                this.init()
            }
        },
        // 获取菜单总条数
        apiworkBenchIndexcountProjectTracking() {
            // apiworkBenchIndexcountProjectTracking().then((res)=>{
            // 	const {data}=res;
            // 	if(data.code=='1'){
            // 		this.navTotal=data.data;
            // 	}
            // })
        },
        // 筛选后获取菜单总条数-工程建设
        apiworkBenchIndexprojectStatusCount() {
            // let listType=this.user.role=='ROLE_JYZX_USER'?2:this.user.role=='ROLE_JYZXSH_USER'?1:1;
            // apiworkBenchIndexprojectStatusCount({
            // 	page:this.paginationOpt.pageIndex,
            //           rows:this.paginationOpt.pageSize,
            // 	filter:{
            // 		listType:listType,//角色类型
            // 		// systemType:this.systemType,
            // 		projectStatusType:this.projectStatusType,//项目状态
            // 		buyprojectType:this.buyprojectType,//项目类型
            // 		bidOpenTimeStart:this.bidOpenTimeStart,
            // 		bidOpenTimeEnd:this.bidOpenTimeEnd,
            // 		buyprojectresultnoticeTimeStart:this.buyprojectresultnoticeTimeStart,
            // 		buyprojectresultnoticeTimeEnd:this.buyprojectresultnoticeTimeEnd
            // 	},
            // 	searchKey:this.searchKey,
            // 	type:this.systemType
            // }).then((res)=>{
            // 	const {data} = res;
            // 	if(data.code=='1'){
            // 		Object.keys(data.data).forEach(key=>{
            // 			this.navTotal[key]=data.data[key];
            // 		})
            // 	}
            // })
        },
        apiSysdatadictionaryGetDictionaryName() {
            let list = {
                'CG': 1,
                'GC': 2,
                'GT': 3,
                'CQ': 4,
                'QT': 5
            }
            this.projectTypeList.push({ name: '全部', value: '' })
            dictDataList(list[this.systemType] || 1).then((res) => {
                const { data } = res;
                if (data.code == '1') {
                    this.projectTypeList.push.apply(this.projectTypeList, data.data);
                }
            })
        },
        // 获取数据
        init() {
            this.superviseDeptCodeList = this.superviseDeptCodeList.length == 0 ? this.uerdefultOptionCode : this.superviseDeptCodeList
            this.fullscreenLoading = true
            listFlowEfficiencyListPaged({
                page: this.paginationOpt.pageIndex,
                rows: this.paginationOpt.pageSize,
                filter: {
                    projectStatus: Number(this.projectStatusType),
                    projectType: this.buyprojectType,
                    busType: this.systemType,
                    bidOpenStartTime: this.bidOpenTimeStart,
                    bidOpenEndTime: this.bidOpenTimeEnd,
                    resultNoticeStartTime: this.buyprojectresultnoticeTimeStart,
                    resultNoticeEndTime: this.buyprojectresultnoticeTimeEnd,
                    entryStartTime: this.projecEntryTimeStart,
                    entryEndTime: this.projecEntryTimeEnd,
                    superviseDeptCodeList: this.superviseDeptCodeList
                },
                searchKey: this.searchKey,
            }).then((res) => {
                const { data } = res;
                if (data.code == 1) {
                    this.dataMsg = data.data.rows || [];
                    this.paginationOpt.total = data.data.total || 0;
                    this.navTotal = { CG: 0, GC: data.data.total, GT: 0, CQ: 0 }
                    this.fullscreenLoading = false
                }

            }).finally(() => {
                this.fullscreenLoading = false
            })
        },
        // 每页长度改变
        sizeChangeHandle(value) {
            this.paginationOpt.pageSize = value;
            this.paginationOpt.pageIndex = 1;
            this.init();
        },
        // 当前页改变
        pageChangeHandle(value) {
            this.paginationOpt.pageIndex = value;
            this.init();
        },
        // 菜单点击事件
        navClickHandle(data) {
            this.systemType = data;
            this.projectTypeList = [];
            this.projectStatusType = '';
            this.paginationOpt = {
                pageIndex: 1,
                pageSize: 5,
                total: 0,
                pageSizes: [5, 10, 15]
            };
            this.apiSysdatadictionaryGetDictionaryName();
            this.init();
        },
        // 搜索点击事件
        searchClickHandle(data, tradeId) {
            this.tradeId = tradeId
            this.searchKey = data;
            this.paginationOpt = {
                pageIndex: 1,
                pageSize: 5,
                total: 0,
                pageSizes: [5, 10, 15]
            };
            this.init();
            // this.apiworkBenchIndexprojectStatusCount();
        },
        projectEmitHandle(data) {
            this.projectStatusType = data.projectStatus;
            this.buyprojectType = data.projectType;
            this.bidOpenTimeStart = data.bidOpenTimeStart;
            this.bidOpenTimeEnd = data.bidOpenTimeEnd;
            this.buyprojectresultnoticeTimeStart = data.buyprojectresultnoticeTimeStart;
            this.buyprojectresultnoticeTimeEnd = data.buyprojectresultnoticeTimeEnd;
            this.projecEntryTimeStart = data.projecEntryTimeStart;
            this.projecEntryTimeEnd = data.projecEntryTimeEnd;
            this.superviseDeptCodeList = data.superviseDeptCodeList || []
            this.paginationOpt = {
                pageIndex: 1,
                pageSize: 5,
                total: 0,
                pageSizes: [5, 10, 15]
            };
            this.init();
            // this.apiworkBenchIndexprojectStatusCount();
        }
    }
}
</script>
<style lang="scss" scoped>
.fullCycle {
    .header {
        background: #ffffff;
        padding: 22px 20px;
    }

    .screen {
        margin: 20px;
        background: #ffffff;
        padding: 15px 24px;
        margin-bottom: 0;
    }

    .my_table {
        // padding: 20px;
        background: #ffffff;
        margin: 20px;
        margin-bottom: 0;
        overflow: hidden;

        .no_message {
            margin-top: 70px;
            height: 350px;
            text-align: center;

            p {
                color: rgba(0, 0, 0, 0.65);
                font-weight: 400;
                margin-top: 15px;
                padding-right: 15px;
            }
        }

        .project_item {
            overflow: hidden;

            .project_par {
                margin: 16px 24px 0;
            }
        }

        .limit {
            // margin-top: 230px;
            text-align: right;
        }
    }

    .radioBox {
        margin: 8px 8px 24px;
        height: 40px;
        line-height: 40px;
        background: #E6F4FF;
        border: 1px solid #BAE1FF;
        padding-left: 20px;
        display: flex;

        &>div {
            margin-right: 24px;
            margin-left: 17px;
            position: relative;

            span {
                display: inline-block;
                position: absolute;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                top: 14px;
                left: -18px;
            }
        }
    }
}
</style>
